<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="create-person-portal-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Add Portal
                        </h4>
                    </div>

                    <loading-spinner v-if="loading"></loading-spinner>

                    <div v-else class="modal-body">
                        <select-form-group
                                v-model="portal"
                                name="portal"
                                label="Portal"
                                :options="portalOptions"
                        ></select-form-group>

                        <text-form-group
                                v-model="externalId"
                                name="external_id"
                                label="External ID"
                                :error="getError('external_id')"
                        ></text-form-group>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>

                        <button type="submit" class="btn btn-black">
                            <i class="fa fa-save"></i> Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import moment from 'moment'
    import notify from '@/notify'
    import Errors from '@/mixins/Errors'
    import Load from '@/mixins/Load'
    import LoadingSpinner from '@/components/Layout/LoadingSpinner'
    import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
    import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

    export default {
        components: {LoadingSpinner, SelectFormGroup, TextFormGroup},

        mixins: [Errors, Load],

        props: ['person'],

        data() {
            return {
                portal: null,
                externalId: null
            }
        },

        mounted() {
            this.listenForClose()

            this.load({portals: '/api/v2/portals'}, () => {
                this.portal = this.portals.data[0].id
            })
        },

        computed: {
            portalOptions() {
                return this.portals.data.map(portal => {
                    return {
                        value: portal.id,
                        label: portal.attributes.name
                    }
                })
            }
        },

        methods: {
            listenForClose() {
                $(this.$el).on('hidden.bs.modal', this.reset)
            },

            submit() {
                http.put('/api/v1/people/' + this.person.data.id + '/portals/' + this.portal, {
                    external_id: this.externalId
                })
                    .then(response => {
                        notify.success('The portal was added')

                        this.$emit('created', response.data)

                        $(this.$el).modal('hide')
                    })
                    .catch(this.catchValidationErrors)
            },

            reset() {
                this.errors = {}

                this.externalId = null

                this.portal = this.portals.data[0].id
            }
        }
    }
</script>
